import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import type { Banner } from '@core/components/banner/banner.interfaces';
import { BannerComponent } from '@core/components/banner/banner.component';
import { InstructionStepperComponent } from '@core/components/instruction-stepper/instruction-stepper.component';
import type { LinearStepInfo } from '@core/components/linear-step-info/linear-step-info.interfaces';
import type { VoucherTemplateInput } from './voucher-template.interface';
import { VoucherHeaderComponent } from '@core/components/voucher-header/voucher-header.component';
import { PvDefaultHeaderComponent } from '@core/components/pv-default-header/pv-default-header.component';
import type { Processors } from '@core/components/processor-selectable/processor-selectable.interfaces';
import { ProcessorStaticViewComponent } from '@core/components/processor-static-view/processor-static-view.component';

@Component({
  selector: 'pdf-voucher-template',
  standalone: true,
  imports: [InstructionStepperComponent, VoucherHeaderComponent, BannerComponent,
    PvDefaultHeaderComponent, ProcessorStaticViewComponent],
  templateUrl: './voucher-template.component.html',
  styleUrl: './voucher-template.component.scss',
})
export class VoucherTemplateComponent implements OnChanges {
  @Input({ required: true }) data: VoucherTemplateInput = {} as VoucherTemplateInput
  @Input() voucherPayin: boolean = false;
  @Input() layout: string = 'default'
  @Input() voucherData: any = null;
  @Input() processors: Processors[] = [];
  @Input() copy = false;
  @Input() color!: string;
  linearStepInfo: LinearStepInfo[] = []
  esResponsive!: boolean;


  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      this.data = changes['data'].currentValue;
      this.linearStepInfo = this.data.LinearStepInfo;
    }
  }

  parseBanner(bank: string, hexColor: string): Banner {
    if (this.voucherData && this.voucherData.processor && this.voucherData.processor.parent == 'Deuna') {
      return {
        processor: '',
        text: 'Estás pagando',
        img: `./assets/svg/deuna.svg`,
        background: '#442E4C',
      }
    } else {
      return {
        processor: bank,
        text: `${bank}`,
        // img: `https://monnet-cash-config.s3.amazonaws.com/banks/${bank}/banner.svg`,
        background: hexColor || '',
      };
    }
  }

  getStepColor() {
    return this.color == 'secondary' ? '#6A00F4' : '#395ae8';
  }
}
